import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Radar } from 'lucide-react';
import { STATUS_META, formatSignedInr, formatSignedPercent } from '../../../utils/gmpBoard';

export const OtherGmpIpos = ({ rows, loading, title = 'Other IPOs in the Grey Market' }) => (
  <section className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <div className="flex items-center justify-between gap-2">
      <h2 className="flex items-center gap-2 text-sm font-extrabold text-slate-900">
        <Radar className="w-4 h-4 text-[#008080]" />
        {title}
      </h2>
      <Link to="/ipo-gmp" className="text-[11px] font-bold text-[#008080] hover:underline whitespace-nowrap">
        View all
      </Link>
    </div>

    {loading ? (
      <ul className="mt-3 space-y-2 animate-pulse">
        {Array.from({ length: 4 }).map((_, i) => (
          <li key={i} className="h-12 rounded-xl bg-slate-100" />
        ))}
      </ul>
    ) : rows.length === 0 ? (
      <p className="text-xs text-slate-500 mt-3">No other IPOs have a grey market quote right now.</p>
    ) : (
      <ul className="mt-3 divide-y divide-slate-100">
        {rows.map((row) => {
          const status = STATUS_META[row.status] || STATUS_META.other;
          const tone = row.gmp > 0 ? 'text-emerald-600' : row.gmp < 0 ? 'text-rose-600' : 'text-slate-600';
          return (
            <li key={row.id}>
              <Link
                to={`/ipo-gmp/${row.slug}`}
                className="group flex items-center gap-3 py-2.5 -mx-2 px-2 rounded-lg hover:bg-slate-50 transition-colors"
              >
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-bold text-slate-800 truncate group-hover:text-[#008080]">{row.name}</div>
                  <div className="text-[11px] text-slate-400">
                    {row.board} · {status.label}
                  </div>
                </div>
                <div className="text-right leading-tight">
                  <div className={`text-sm font-extrabold ${tone}`}>{formatSignedInr(row.gmp)}</div>
                  {row.gmpPercent !== null && (
                    <div className={`text-[11px] font-semibold ${tone}`}>{formatSignedPercent(row.gmpPercent)}</div>
                  )}
                </div>
                <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-[#008080] flex-shrink-0" />
              </Link>
            </li>
          );
        })}
      </ul>
    )}
  </section>
);

export default OtherGmpIpos;
